import {Color} from '@/Types/Enums/Color'
import {EnrollmentStatus} from '@/Types/Enums/EnrollmentStatus'

export const getEnrollmentStatusColor = (status:EnrollmentStatus):Color => {
	if(status === EnrollmentStatus.Pending){
		return Color.Yellow
	}
	if(status === EnrollmentStatus.Incomplete){
		return Color.Orange
	}
	if(status === EnrollmentStatus.Paid){
		return Color.Green
	}
	if(status === EnrollmentStatus.Attached){
		return Color.Orange
	}
	if(status === EnrollmentStatus.Accepted){
		return Color.Teal
	}
	if(status === EnrollmentStatus.Rejected){
		return Color.Red
	}
	return Color.Neutral
}